import React, { useEffect, useState } from "react";
import { INVOICE_TRACKING_HOSTNAME } from "../../../../common-utilities/utils/end-points";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { APPROVAL_ROLES, APPROVAL_TYPES } from "./helper";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import "./index.scss";
import { toast } from "react-toastify";
import CustomModal from "../../../../common-utilities/core/modal";
import { REST_URLS } from "../../../../common-utilities/utils/end-points/invoice-tracking";

const ApprovalConfig = ({ docType }) => {
  const [approvalDetails, setApprovalDetails] = useState({});
  const [deleteStage, setDeleteStage] = useState(null);
  const { stages = [], id } = approvalDetails;

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LG_APPROVAL_CONFIG}`,
      null,
      {
        page: 1,
        limit: 20,
        // docType: docType
      }
    )
      .then((response) => {
        if (response.message) {
        } else if (response.id) {
          setApprovalDetails(response || {});
        }
      })
      .catch((err) => {});
  };

  const onUpdate = () => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LG_APPROVAL_CONFIG}/${id}`,
      {
        stages: approvalDetails.stages.map((s) => ({
          stageName: s.stageName,
          approverRoles:
            typeof s.approverRoles === "string"
              ? [s.approverRoles]
              : s.approverRoles,
          approvalType: s.approvalType,
          docUpload: !!s.docUpload,
        })),
      }
    )
      .then((response) => {
        if (response.message) {
        } else {
          toast.success("Approval Config Updated Successfully");
          loadData();
        }
      })
      .catch((err) => {});
  };

  const onDelete = (stageNumber) => {
    let payload = {
      stages: stages
        .filter((s) => s.stageNumber !== stageNumber)
        .map((s) => {
          return {
            stageName: s.stageName,
            approverRoles: s.approverRoles,
            approvalType: s.approvalType,
            docUpload: !!s.docUpload,
          };
        }),
    };

    invokeApi(
      HTTP_METHODS.PUT,
      `${INVOICE_TRACKING_HOSTNAME}${REST_URLS.LG_APPROVAL_CONFIG}/${id}`,
      payload
    )
      .then((response) => {
        if (response.message) {
        } else {
          toast.success("Approval Config Updated Successfully");
          loadData();
        }
      })
      .catch((err) => {});
  };
  console.log("DOC", approvalDetails);
  return (
    <Box>
      <Stack direction="row" spacing={2} justifyContent="flex-end">
        <Button
          variant="contained"
          onClick={() => {
            setApprovalDetails((prev) => {
              prev.stages.push({
                stageNumber: prev.stages.length + 1,
                stageName: "",
                approverRole: "",
              });
              return { ...prev };
            });
          }}
        >
          Add New Stage
        </Button>
      </Stack>
      <Box sx={{ mt: 2 }}>
        {approvalDetails?.stages?.map((stage, index) => {
          return (
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={0.8}>
                <TextField
                  fullWidth
                  size="small"
                  label="Stage No"
                  value={stage.stageNumber}
                  disabled
                />
              </Grid>
              <Grid item xs={1.5}>
                <TextField
                  fullWidth
                  label="Stage Name"
                  size="small"
                  value={stage.stageName}
                  onChange={(e) => {
                    setApprovalDetails((prev) => {
                      prev.stages[index].stageName = e.target.value;
                      return { ...prev };
                    });
                  }}
                />
              </Grid>
              <Grid item xs={1.6}>
                <Autocomplete
                  options={APPROVAL_TYPES}
                  size="small"
                  getOptionLabel={(option) => option}
                  getOptionValue={(option) => option}
                  value={stage.approvalType}
                  onChange={(e, val) => {
                    setApprovalDetails((prev) => {
                      prev.stages[index].approvalType = val;
                      return { ...prev };
                    });
                  }}
                  renderInput={(params) => (
                    <TextField size="small" {...params} label="Approver Type" />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <Autocomplete
                  options={APPROVAL_ROLES}
                  size="small"
                  multiple={stage.approvalType === "PARALLEL"}
                  getOptionLabel={(option) => option}
                  isOptionEqualToValue={(option, value) => option === value}
                  value={
                    stage.approvalType === "PARALLEL"
                      ? Array.isArray(stage.approverRoles)
                        ? stage.approverRoles
                        : []
                      : Array.isArray(stage.approverRoles)
                      ? stage.approverRoles[0] || ""
                      : stage.approverRoles || ""
                  }
                  onChange={(e, val) => {
                    setApprovalDetails((prev) => {
                      prev.stages[index].approverRoles =
                        stage.approvalType === "PARALLEL"
                          ? val
                          : val
                          ? [val]
                          : [];
                      return { ...prev };
                    });
                  }}
                  renderInput={(params) => (
                    <TextField size="small" {...params} label="Approver Role" />
                  )}
                />
              </Grid>
              <Grid item xs={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={stage?.docUpload}
                      onChange={() => {
                        setApprovalDetails((prev) => {
                          prev.stages[index].docUpload =
                            !prev.stages[index].docUpload;
                          return { ...prev };
                        });
                      }}
                    />
                  }
                  label="Document Needed"
                  labelPlacement="end"
                />
              </Grid>
              <Grid item xs={2}>
                <Button
                  variant="outlined"
                  onClick={() => onDelete(stage.stageNumber)}
                  sx={{ mr: 2 }}
                >
                  Delete
                </Button>
                <Button variant="outlined" onClick={onUpdate}>
                  Update
                </Button>
              </Grid>
            </Grid>
          );
        })}
      </Box>

      {deleteStage && (
        <CustomModal
          title="Delete Stage"
          disabledOutsideClick={true}
          onClose={() => {
            setDeleteStage(null);
          }}
        >
          <div className="b-modal-form-container">
            <Typography variant="h5">Are you sure ? </Typography>
            <Button variant="outlined" onClick={onDelete} fullWidth>
              Delete
            </Button>
          </div>
        </CustomModal>
      )}
    </Box>
  );
};

export default ApprovalConfig;
